import React from "react";
import Career from "./Components/Career/Career";
import Contact from "./Components/Contact/Contact";
import Footer from "./Components/Footer/Footer";
import Header from "./Components/Header/Header";
import Home from "./Components/Home/Home";
import Tech from "./Components/Tech/Tech";
import Work from "./Components/Work/Work";
import WOW from 'wowjs';

class App extends React.Component {
  componentDidMount() {
    new WOW.WOW({
      live: false
    }).init();
  }
  render() {
    return (
      <>
        <Header />
        <main>
          <Home />
          <Tech />
          <Career />
          <Work />
          <Contact />
        </main>
        <Footer />
      </>
    )
  }
};

export default App;
